import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';
import { SeriesTypeEnum } from '../../../Common/Reports/enums/series-type.enum';

export class SeriesCountFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    options: DropdownOptionModel[];
    min: number;
    max: number;
    defaultValue: number;
    type: SeriesTypeEnum;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        min: number,
        max: number,
        defaultValue: number,
        type: SeriesTypeEnum,
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.options = [];
        for (let i = min; i <= max; i++) {
            this.options.push({label: `${i}`, value: i});
        }
        this.min = min;
        this.max = max;
        this.defaultValue = defaultValue;
        this.type = type;
    }
}
